const topics = [
  { label: '范马刃牙', count: '3.2万' },
  { label: '宫本武藏', count: '2.8万' },
  { label: '地下斗技场', count: '2.5万' },
  { label: '最凶死刑犯', count: '2.1万' },
  { label: '范马勇次郎', count: '1.9万' },
  { label: '相扑道', count: '1.7万' },
  { label: '花山薰', count: '1.5万' },
  { label: '愚地独步', count: '1.3万' },
  { label: '皮可', count: '1.1万' },
  { label: '镐昴升', count: '0.9万' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-600 text-center mb-10 max-w-lg mx-auto">
          刃牙漫画读者社区最热讨论话题，看看大家都在聊什么
        </p>
        <div className="max-w-3xl mx-auto flex flex-wrap justify-center gap-3">
          {topics.map((item) => (
            <div
              key={item.label}
              className="group cursor-pointer px-5 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300/60 hover:bg-primary-50/50 transition-all flex items-center gap-2"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                #{item.label}
              </span>
              <span className="text-[11px] text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded-full whitespace-nowrap">
                {item.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}